export default __webpack_public_path__ + "static/media/sudan-beats.11b4270a.png";